import { useFormik } from "formik";
import {
  adminGetComboWorkLocation,
  adminGetMemberById,
  adminUpdateMember,
} from "helpers/backend_helpers";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import Flatpickr from "react-flatpickr";
import Zoom from "react-medium-image-zoom";
import { Indonesian } from "flatpickr/dist/l10n/id.js";
import {
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import * as Yup from "yup";
import moment from "moment";
import "../../pages/Info/style.css";

const UpdateModalMember = ({ show, onCloseClick, getData, data }: any) => {
  const [detailData, setDetailData] = useState<any>({});
  const [comboLocation, setComboLocation] = useState<any>([]);
  const [selectedImage, setSelectedImage] = useState<any>(null);
  const [imageFile, setImageFile] = useState<File | null>(null);

  const getDetailData = async () => {
    await adminGetMemberById(data._id)
      .then((response: any) => {
        setDetailData(response);
      })
      .catch(() => {});
  };

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: detailData?.name || "",
      noId: detailData?.noId || "",
      phoneNumber: detailData?.phoneNumber || "",
      workLocation: {
        value: detailData?.workLocation,
        label: detailData.workLocationName,
      },
      profilePicture: detailData?.profilePicture || "",
      address: detailData?.address || "",
      birthDate: detailData?.birthDate || "",
      birthPlace: detailData?.birthPlace || "",
      category: {
        value: detailData.category,
        label: detailData.category,
      },
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Nama harus diisi!"),
      noId: Yup.string().required("No Reg harus diisi!"),
      phoneNumber: Yup.string().required("No Telp harus diisi!"),
      workLocation: Yup.object()
        .shape({
          value: Yup.string().required(),
          label: Yup.string().required(),
        })
        .required("Lokasi kerja harus diisi!"),
      profilePicture: Yup.string(),
      address: Yup.string().required("Alamat harus diisi!"),
      birthDate: Yup.string().required("Tanggal lahir harus diisi!"),
      birthPlace: Yup.string().required("Tempat lahir harus diisi!"),
      category: Yup.object()
        .shape({
          value: Yup.string().required(),
          label: Yup.string().required(),
        })
        .required("Kategori karyawan harus diisi!"),
    }),
    onSubmit: (values) => {
      const formData = new FormData();

      formData.append("name", values.name);
      formData.append("noId", values.noId);
      formData.append("phoneNumber", values.phoneNumber);
      formData.append("workLocation", values.workLocation.value);
      formData.append("address", values.address);
      formData.append("birthPlace", values.birthPlace);
      formData.append("birthDate", values.birthDate);
      formData.append("category", values.category.value);

      if (imageFile) {
        formData.append("profilePicture", imageFile);
      }

      adminUpdateMember(data._id, formData)
        .then((response: any) => {
          onCloseClick();
          getData();
          toast.success(
            <div>
              Karyawan <b>{response?.name}</b> berhasil diubah!
            </div>
          );
          validation.resetForm();
          setSelectedImage(null);
          setImageFile(null);
        })
        .catch(() => {});
    },
  });

  const getComboLocation = async () => {
    await adminGetComboWorkLocation()
      .then((response: any) => {
        setComboLocation(
          response.map((val: any) => {
            return { value: val._id, label: val.name };
          })
        );
      })
      .catch(() => {});
  };

  const handleImageChange = (event: any) => {
    const file = event.target.files[0];
    if (!file) return;

    setImageFile(file);

    const reader = new FileReader();
    reader.onload = (e: any) => {
      setSelectedImage(e.target.result);
    };
    reader.readAsDataURL(file);
  };

  const comboCategory = [
    { value: "EMPLOYEE", label: "EMPLOYEE" },
    { value: "SECURITY", label: "SECURITY" },
    { value: "CLEANING_SERVICE", label: "CLEANING SERVICE" },
    { value: "OFFICE_BOY", label: "OFFICE BOY" },
    { value: "DRIVER", label: "DRIVER" },
    { value: "GARDENER", label: "GARDENER" },
  ];

  useEffect(() => {
    if (!show) {
      validation.resetForm();
      setSelectedImage(null);
      setImageFile(null);
    }
  }, [show]);

  useEffect(() => {
    if (show) {
      getDetailData();
      getComboLocation();
    }
  }, [show]);

  return (
    <Modal
      size="lg"
      fade={true}
      isOpen={show}
      toggle={onCloseClick}
      centered={true}
    >
      <ModalHeader className="bg-light p-3" toggle={onCloseClick}>
        Edit Karyawan
      </ModalHeader>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}
      >
        <ModalBody>
          <Row className="g-3">
            <Col lg={12}>
              <div className="text-center">
                <div className="position-relative d-inline-block">
                  <div className="position-absolute bottom-0 end-0">
                    <Label htmlFor="profilePicture" className="mb-0">
                      <div className="avatar-xs cursor-pointer">
                        <div className="avatar-title bg-light border rounded-circle text-muted">
                          <i className="ri-image-fill"></i>
                        </div>
                      </div>
                    </Label>
                    <Input
                      name="profilePicture"
                      className="form-control d-none"
                      id="profilePicture"
                      type="file"
                      accept="image/png, image/gif, image/jpeg"
                      onChange={handleImageChange}
                    />
                  </div>
                  <div className="avatar-lg p-1">
                    <div className="avatar-title bg-light rounded-circle">
                      <Zoom>
                        <img
                          src={
                            selectedImage ||
                            validation.values.profilePicture ||
                            "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg"
                          }
                          alt="profilePicture"
                          id="profilePicture"
                          className="avatar-md rounded-circle object-fit-cover"
                          style={{ cursor: "zoom-in" }}
                        />
                      </Zoom>
                    </div>
                  </div>
                </div>
                <h5 className="fs-13 mt-3">Foto</h5>
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <Label htmlFor="name" className="form-label">
                  Nama <span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  placeholder="Nama"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.name || ""}
                  invalid={
                    validation.touched.name && validation.errors.name
                      ? true
                      : false
                  }
                />
                {validation.errors.name && validation.touched.name ? (
                  <FormFeedback type="invalid">
                    {validation.errors.name}
                  </FormFeedback>
                ) : null}
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <Label for="phoneNumber" className="form-label">
                  No Telp <span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  className="form-control"
                  id="phoneNumber"
                  name="phoneNumber"
                  placeholder="No Telp"
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    validation.setFieldValue("phoneNumber", value);
                  }}
                  onBlur={validation.handleBlur}
                  value={validation.values.phoneNumber || ""}
                  invalid={
                    validation.touched.phoneNumber &&
                    validation.errors.phoneNumber
                      ? true
                      : false
                  }
                />
                {validation.errors.phoneNumber &&
                validation.touched.phoneNumber ? (
                  <FormFeedback type="invalid">
                    {validation.errors.phoneNumber}
                  </FormFeedback>
                ) : null}
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <Label htmlFor="noId" className="form-label">
                  No Reg <span className="text-danger">*</span>
                </Label>
                <Input
                  disabled
                  type="text"
                  className="form-control"
                  id="noId"
                  name="noId"
                  placeholder="No Reg"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.noId || ""}
                  invalid={
                    validation.touched.noId && validation.errors.noId
                      ? true
                      : false
                  }
                />
                {validation.errors.noId && validation.touched.noId ? (
                  <FormFeedback type="invalid">
                    {validation.errors.noId}
                  </FormFeedback>
                ) : null}
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <Label htmlFor="birthPlace" className="form-label">
                  Tempat Lahir <span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  className="form-control"
                  id="birthPlace"
                  name="birthPlace"
                  placeholder="Nama"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.birthPlace || ""}
                  invalid={
                    validation.touched.birthPlace &&
                    validation.errors.birthPlace
                      ? true
                      : false
                  }
                />
                {validation.errors.birthPlace &&
                validation.touched.birthPlace ? (
                  <FormFeedback type="invalid">
                    {validation.errors.birthPlace}
                  </FormFeedback>
                ) : null}
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <Label htmlFor="workLocation" className="form-label">
                  Lokasi Kerja <span className="text-danger">*</span>
                </Label>
                <Select
                  value={validation.values.workLocation || ""}
                  onChange={(e: any) => {
                    validation.setFieldValue("workLocation", e);
                  }}
                  options={comboLocation}
                  className={`basic-multi-select ${
                    validation.errors.workLocation &&
                    validation.touched.workLocation
                      ? "is-invalid"
                      : ""
                  }`}
                  classNamePrefix="select"
                  placeholder="Pilih Lokasi Kerja"
                />
                {validation.errors.workLocation &&
                validation.touched.workLocation ? (
                  <div className="invalid-feedback d-block">
                    {validation.errors.workLocation}
                  </div>
                ) : null}
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <Label htmlFor="birthDate" className="form-label">
                  Tanggal Lahir <span className="text-danger">*</span>
                </Label>
                <Flatpickr
                  name="birthDate"
                  id="date-field"
                  className="form-control"
                  placeholder="Pilih Tanggal Kadaluwarsa"
                  options={{
                    locale: Indonesian,
                    altInput: true,
                    altFormat: "d F Y",
                    dateFormat: "Y-m-d",
                  }}
                  onChange={(date: any) =>
                    validation.setFieldValue(
                      "birthDate",
                      moment(date[0]).format("YYYY-MM-DD")
                    )
                  }
                  value={validation.values.birthDate || ""}
                />
                {validation.errors.birthDate && validation.touched.birthDate ? (
                  <FormFeedback type="invalid" className="d-block">
                    {validation.errors.birthDate}
                  </FormFeedback>
                ) : null}
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <Label htmlFor="category" className="form-label">
                  Tipe Karyawan <span className="text-danger">*</span>
                </Label>
                <Select
                  value={validation.values.category || ""}
                  onChange={(e: any) => {
                    validation.setFieldValue("category", e);
                  }}
                  options={comboCategory}
                  className={`basic-multi-select ${
                    validation.errors.category && validation.touched.category
                      ? "is-invalid"
                      : ""
                  }`}
                  classNamePrefix="select"
                  placeholder="Pilih Tipe Karyawan"
                />
                {validation.errors.category && validation.touched.category ? (
                  <div className="invalid-feedback d-block">
                    {validation.errors.category}
                  </div>
                ) : null}
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <Label htmlFor="address" className="form-label">
                  Alamat <span className="text-danger">*</span>
                </Label>
                <Input
                  type="textarea"
                  className="form-control"
                  id="address"
                  rows={3}
                  placeholder="Alamat"
                  name="address"
                  value={validation.values.address || ""}
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  invalid={
                    validation.touched.address && validation.errors.address
                      ? true
                      : false
                  }
                />
                {validation.touched.address && validation.errors.address ? (
                  <FormFeedback type="invalid">
                    {validation.errors.address}
                  </FormFeedback>
                ) : null}
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-soft-danger waves-effect waves-light material-shadow-none btn-sm"
            data-bs-dismiss="modal"
            onClick={onCloseClick}
          >
            Batal
          </button>
          <button
            type="submit"
            className="btn btn-soft-success waves-effect waves-light material-shadow-none btn-sm"
          >
            Simpan
          </button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

UpdateModalMember.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  getData: PropTypes.func,
  data: PropTypes.any,
};

export default UpdateModalMember;
